<template>
  <div class="overflow-auto">
    <div v-html="task.taskDesc" class="mx-wd-100p"></div>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
